import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    return value;
  } else {
    return "Swiped";
  }
}

const EntryPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
        <Row>
            <Col><strong>{data.label}</strong></Col>
            <Col>{getValue(data.value)}</Col>
        </Row>
  ),
  id: 'entryPropertyPlugin',
  title: 'Entry Property',
  description: 'Entry Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Entry',
        },
      },
      required: ['label'],
    },
  },
};

export default EntryPropertyPlugin;